export default function flipBoxWidget(editor) {
  editor.DomComponents.addType('eb-flip-box', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-flip-box'
    },
    model: {
      defaults: {
        name: 'Flip Box',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-flip-box' },
        style: {
          'perspective': '1000px',
          'width': '300px',
          'height': '300px',
          'margin': '0 auto',
        },
        components: `
          <style>
            .eb-flip-inner { position: relative; width: 100%; height: 100%; transition: transform 0.6s; transform-style: preserve-3d; }
            .eb-flip-box-wrap:hover .eb-flip-inner { transform: rotateY(180deg); }
            .eb-flip-front, .eb-flip-back { position: absolute; width: 100%; height: 100%; backface-visibility: hidden; border-radius: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 30px; box-sizing: border-box; }
            .eb-flip-front { background: linear-gradient(135deg, #667eea, #764ba2); color: #fff; }
            .eb-flip-back { background: #fff; border: 2px solid #667eea; color: #333; transform: rotateY(180deg); }
          </style>
          <div class="eb-flip-box-wrap" style="width:100%;height:100%;">
            <div class="eb-flip-inner">
              <div class="eb-flip-front">
                <div style="font-size:48px;margin-bottom:15px;"><i class="fa fa-rocket"></i></div>
                <h3 style="font-size:22px;font-weight:700;margin:0;">Front Side</h3>
                <p style="font-size:14px;margin:10px 0 0;opacity:0.9;">Hover to see the back</p>
              </div>
              <div class="eb-flip-back">
                <h3 style="font-size:20px;font-weight:600;color:#667eea;margin:0 0 10px;">Back Side</h3>
                <p style="font-size:14px;color:#666;line-height:1.6;margin:0 0 20px;text-align:center;">Additional details or a call to action goes here.</p>
                <a href="#" style="padding:10px 28px;background:#667eea;color:#fff;text-decoration:none;border-radius:5px;font-size:14px;font-weight:600;">Learn More</a>
              </div>
            </div>
          </div>
        `,
        traits: [
          { type: 'select', name: 'data-flip-direction', label: 'Flip Direction', options: [
            { id: 'horizontal', label: 'Horizontal' },
            { id: 'vertical', label: 'Vertical' },
          ]},
        ],
      },
    },
  })

  editor.BlockManager.add('eb-flip-box', {
    label: 'Flip Box',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19,8L15,12H18A6,6 0 0,1 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20A8,8 0 0,0 20,12H23M6,12A6,6 0 0,1 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4A8,8 0 0,0 4,12H1L5,16L9,12"/></svg>',
    content: { type: 'eb-flip-box' },
  })
}
